<template>
  <v-footer color="secondary" app>
    <span class="white--text">مركز تفسير &copy; {{ (new Date).getFullYear() }}</span>

    <v-spacer />

    <span dir="ltr" class="grey--text text--lighten-2">
      Powered by |
      <a href="http://www.nawah.ai" target="_blank" class="grey--text text--lighten-2">Nawah.ai</a>
    </span>

    <v-spacer />

    <v-chip color="secondary lighten-1">
      <span dir="ltr">{{ require("@/../package.json").version }}</span>
      <v-avatar right class="secondary">V</v-avatar>
    </v-chip>
  </v-footer>
</template>


<script>
export default {
  name: "app-footer"
};
</script>